import { gsap, ScrollTrigger, useMotion } from '../lib/motion';

const styles = [
  "Knotless Braids", "Box Braids", "Nagô", "Fulani Braids", "French Curl", "Passion Locs",
  "Gipsy Braids", "Lemonade Braids", "Island Twist", "Big Braids", "Crochet Braids", "Slim Braids",
];

// Única faixa corrida da página: mostra a variedade de estilos da agenda.
// Acelera com a velocidade da rolagem e inverte o sentido quando a pessoa sobe.
export default function StyleMarquee() {
  const scope = useMotion((root) => {
    const loop = gsap.to(root.querySelector('[data-track]'), {
      xPercent: -50,
      duration: 50,
      ease: 'none',
      repeat: -1,
    });
    // Começa "no meio" das repetições para poder andar de ré sem travar no zero.
    loop.totalTime(loop.duration() * 100);

    ScrollTrigger.create({
      trigger: root,
      start: 'top bottom',
      end: 'bottom top',
      onUpdate: (self) => {
        const boost = gsap.utils.clamp(1, 10, Math.abs(self.getVelocity()) / 120);
        gsap.fromTo(
          loop,
          { timeScale: self.direction * boost },
          { timeScale: self.direction, duration: 1.4, ease: 'power2.out', overwrite: true }
        );
      },
    });
  });

  return (
    <section ref={scope} aria-label="Alguns estilos da agenda" className="overflow-hidden pb-16 md:pb-24">
      <div data-track className="flex w-max">
        {[0, 1].map((copy) => (
          <ul
            key={copy}
            aria-hidden={copy === 1 ? 'true' : undefined}
            className="flex shrink-0 items-center gap-8 md:gap-14 pr-8 md:pr-14"
          >
            {styles.map((style, i) => (
              <li
                key={style}
                className={`whitespace-nowrap text-5xl md:text-8xl font-extrabold tracking-tighter leading-[1.1] ${
                  i % 2 ? 'text-tan' : 'text-ink'
                }`}
              >
                {style}
              </li>
            ))}
          </ul>
        ))}
      </div>
    </section>
  );
}
